import { render, staticRenderFns } from "./ProductOrdersOrdered.vue?vue&type=template&id=47fce8b0"
import script from "./ProductOrdersOrdered.vue?vue&type=script&lang=ts"
export * from "./ProductOrdersOrdered.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports